import React from 'react';
import {
  LuLayoutDashboard,
  LuSearch,
  LuSend,
  LuSettings,
  LuTarget,
  LuMessageCircle,
} from 'react-icons/lu';
import { FaListCheck } from "react-icons/fa6";
import { LiaFacebookMessenger } from "react-icons/lia";
import './Sidebar.css';

function Sidebar({ currentStage, setCurrentStage, open = false }) {
  const items = [
    { id: 'dashboard', label: 'Dashboard', icon: <LuLayoutDashboard /> },
    { id: 'leadfinder', label: 'Lead Finder', icon: <LuTarget /> },
    { id: 'whatsapp', label: 'WhatsApp', icon: <LuMessageCircle /> },
    { id: 'stage1', label: 'Lead Scraping', icon: <LuSearch /> },
    { id: 'stage4', label: 'FB Ads Scraper', icon: <LiaFacebookMessenger /> },
    { id: 'stage2', label: 'Manual Review', icon: <FaListCheck /> },
    { id: 'stage3', label: 'DM Automation', icon: <LuSend /> },
    { id: 'settings', label: 'Settings', icon: <LuSettings /> },
  ];

  return (
    <aside className={`custom-sidebar ${open ? "open" : ""}`}>
      <nav className="stage-nav">
        {items.map((item) => (
          <button
            key={item.id}
            className={`stage-btn ${currentStage === item.id ? 'active' : ''}`}
            onClick={() => setCurrentStage(item.id)}
            type="button"
          >
            <span className="stage-icon">{item.icon}</span>
            <span className="stage-label">{item.label}</span>
            {currentStage === item.id && <span className="stage-accent" aria-hidden />}
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;


